import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
  navBar: PropTypes.node,
  subHeader: PropTypes.node,
  location: PropTypes.object,
  footer: PropTypes.node,
};

const defaultProps = {
  navBar: false,
  subHeader: {},
  location: {},
  footer: null,
};

export { propTypes, defaultProps };
